import type { CouponDiscountType } from '../enums/coupon-discount-type.enum';
import type { FullAuditedEntityDto, PagedAndSortedResultRequestDto } from '@abp/ng.core';
import type { CouponStatus } from '../enums/coupon-status.enum';

export interface ApplyCouponDto {
  code?: string;
  orderId: number;
  userId?: string;
}

export interface ApplyCouponResultDto {
  success: boolean;
  message?: string;
  discountApplied: number;
  newTotal: number;
}

export interface ClientLookupDto {
  id: number;
  displayName?: string;
}

export interface CouponBasicDto {
  id?: string;
  code?: string;
  discountType?: CouponDiscountType;
  discountValue: number;
}

export interface CouponCheckStatusResultDto {
  updatedCount: number;
  totalCount: number;
  activatedCount: number;
  expiredCount: number;
  activatedCodes: string[];
  expiredCodes: string[];
  currentActiveCount: number;
  currentExpiredCount: number;
  currentActiveCodes: string[];
  currentExpiredCodes: string[];
  message?: string;
}

export interface CouponDto extends FullAuditedEntityDto<string> {
  code?: string;
  discountType?: CouponDiscountType;
  discountValue: number;
  startDate?: string;
  endDate?: string;
  maxUses?: number;
  usedCount: number;
  assignedToSommelierId?: string;
  sommelierName?: string;
  isActive: boolean;
  status?: CouponStatus;
  sommelierIds: number[];
  wineIds: number[];
  clientIds: number[];
  minimumAmount?: number;
}

export interface CouponItemValidationDto {
  wineId: number;
  unitPrice: number;
  quantity: number;
}

export interface CouponReportDto {
  couponCode?: string;
  usedCount: number;
  totalDiscount: number;
  sommelierName?: string;
  firstUsed?: string;
  lastUsed?: string;
  sommelierDisplay?: string;
  wineDisplay?: string;
  clientDisplay?: string;
}

export interface CouponReportFilterDto {
  fromDate?: string;
  toDate?: string;
  sommelierId?: string;
  discountType?: CouponDiscountType;
  filter?: string;
}

export interface CouponValidationDto {
  code?: string;
  orderTotal: number;
  sommelierId?: string;
  clientUserId?: string;
  items: CouponItemValidationDto[];
}

export interface CouponValidationResultDto {
  valid: boolean;
  message?: string;
  coupon: CouponBasicDto;
  discountAmount: number;
}

export interface CreateCouponDto {
  code?: string;
  discountType?: CouponDiscountType;
  discountValue: number;
  startDate?: string;
  endDate?: string;
  maxUses?: number;
  assignedToSommelierId?: string;
  isActive: boolean;
  sommelierIds: number[];
  wineIds: number[];
  clientIds: number[];
  minimumAmount?: number;
}

export interface GetCouponsInput extends PagedAndSortedResultRequestDto {
  filter?: string;
  status?: CouponStatus;
  sommelierId?: string;
  discountType?: CouponDiscountType;
}

export interface UpdateCouponDto {
  code?: string;
  discountType?: CouponDiscountType;
  discountValue: number;
  startDate?: string;
  endDate?: string;
  maxUses?: number;
  assignedToSommelierId?: string;
  isActive: boolean;
  sommelierIds: number[];
  wineIds: number[];
  clientIds: number[];
  minimumAmount?: number;
}
